export function getSlideWidth(carouselElem, slidesToShow, { slidesPreviewWidth = 0 } = {}) {
  return (getWidth(carouselElem) - 2 * slidesPreviewWidth) / slidesToShow;
}

export function getWidth(elem) {
  return elem ? elem.getBoundingClientRect().width || elem.offsetWidth : 0;
}

export function getTrackLeft(slidesCount, slidesPerPage, slideIndex, slideWidth, slidesPreviewWidth) {
  if (slideIndex === 0) {
    return 0;
  }

  if (slideIndex >= slidesCount - slidesPerPage) {
    return slideIndex * slideWidth * (-1) + 2 * slidesPreviewWidth;
  }

  return slideIndex * slideWidth * (-1) + slidesPreviewWidth;
}



// WEBPACK FOOTER //
// ./src/mobile/views/home/components/mobile-carousel/sizes.js